<script setup lang="ts">
import api from "@/api";
import {
	TAG_TYPES,
	type TPagination,
	type TTag,
} from "@/assets/js/globalTypes";
import {
	debounce,
	formatPagination,
	getRequestPagination,
	updatePagination,
} from "@/assets/js/helpers";

import {
	openConfirmDeleteModal,
	openCreateTagModal,
} from "@/components/modals/modalDefinitions";
import { useToastStore } from "@/store/toast";
import type { PageState } from "primevue/paginator";

definePage({
	name: "admin.system.skills",
	meta: {
		permissions: "view-system-management",
	},
});

const skillsSearch = ref("");
const programSearch = ref("");

const toastStore = useToastStore();

const skills = ref<TTag[]>([]);
const programs = ref<TTag[]>([]);

const skillsPagination = ref<TPagination | null>(null);
const programPagination = ref<TPagination | null>(null);

async function getSkills(pagination?: PageState) {
	if (pagination) {
		const updatedPagination = formatPagination(pagination);
		updatePagination(skillsPagination, updatedPagination);
	}

	try {
		const res = await api.getAllSkills({
			tag_name: skillsSearch.value,
			...getRequestPagination(skillsPagination.value),
		});
		skills.value = res.data.data || [];
		skillsPagination.value = res.data.meta?.pagination || null;
	} catch (error) {
		console.error(error);
	}
}
async function getPrograms(pagination?: PageState) {
	if (pagination) {
		const updatedPagination = formatPagination(pagination);
		updatePagination(skillsPagination, updatedPagination);
	}
	try {
		const res = await api.getAllPrograms({
			tag_name: programSearch.value,
			...getRequestPagination(programPagination.value),
		});
		programs.value = res.data.data || [];
	} catch (error) {
		console.error(error);
	}
}

const getSkillsDebounced = debounce(getSkills, 500, false);
const getProgramsDebounced = debounce(getPrograms, 500, false);

watch(skillsSearch, getSkillsDebounced);
watch(programSearch, getProgramsDebounced);

onMounted(() => {
	getSkills();
	// getPrograms;
});

function callOpenCreateTagModal(tagType: TTag["tag_type"]) {
	const action = tagType === TAG_TYPES.SKILLS ? getSkills : getPrograms;
	openCreateTagModal({ tagType, onConfirm: action });
}

function openEditTagModal(tag: TTag, tagType: TTag["tag_type"]) {
	openCreateTagModal({
		tagId: tag.tag_id,
		tagType: tagType,
		onConfirm: getSkills,
	});
}

function openConfrimDeleteTagModal(tag: TTag, tagType: TTag["tag_type"]) {
	const action = tagType === TAG_TYPES.SKILLS ? getSkills : getPrograms;
	openConfirmDeleteModal({
		name: tag.tag_name,
		data: tag,
		onConfirm: async () => {
			try {
				const res = await api.deleteTag({
					tag_id: tag.tag_id,
					tag_type: tag.tgt_code,
				});
				toastStore.openToastSuccess(res.data.message);
				action();
			} catch (e) {
				toastStore.openToastError(e.response.data.message);
			}
		},
	});
}
</script>
<template>
	<div id="subjects-page">
		<div class="item">
			<div class="item">
				<h2>{{ $t("app.tags." + TAG_TYPES.SKILLS.toLowerCase(), 2) }}</h2>
				<div class="info-wrap">
					<p-input-text
						id="natures-search"
						v-model="skillsSearch"
						:placeholder="$t('app.base.search')"
					/>
					<p-button @click="callOpenCreateTagModal(TAG_TYPES.SKILLS)">
						<i-ic-outline-add class="large" />

						{{ $t("app.base.add", 2).trim() }}
					</p-button>
				</div>
				<system-tag-list
					:tag-type="TAG_TYPES.SKILLS"
					:tags="skills"
					:pagination="skillsPagination"
					@change-page="getSkills"
					@delete-tag="openConfrimDeleteTagModal($event, TAG_TYPES.SKILLS)"
					@edit-tag="openEditTagModal($event, TAG_TYPES.SKILLS)"
				/>
			</div>
		</div>
		<!-- <div class="item">
			<h2>{{ $t("app.tags." + TAG_TYPES.PROGRAMS.toLowerCase(), 2) }}</h2>
			<div class="info-wrap">
				<p-input-text
					id="natures-search"
					v-model="programSearch"
					:placeholder="$t('app.base.search')"
				/>
				<p-button @click="callOpenCreateTagModal(TAG_TYPES.PROGRAMS)">
					<i-ic-outline-add class="large" />

					{{ $t("app.base.add", 2).trim() }}
				</p-button>
			</div>
			<system-tag-list
				:tag-type="TAG_TYPES.PROGRAMS"
				:tags="programs"
				:pagination="programPagination"
				@change-page="getPrograms"
				@delete-tag="openConfrimDeleteTagModal($event, TAG_TYPES.PROGRAMS)"
				@edit-tag="openEditTagModal($event, TAG_TYPES.PROGRAMS)"
			/>
		</div> -->
	</div>
</template>

<style scoped lang="scss">
#subjects-page {
	display: flex;
	gap: 3rem;
	padding: 1rem;
	.item {
		flex-grow: 1;
		max-width: 30vw;
	}
	.info-wrap {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 0.5rem 0;
	}
}
</style>
